import styled from "styled-components";
import { Dropdown } from "react-bootstrap";

export const EvaluationTypeContainer = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

export const EvaluationTypeToggle = styled(Dropdown.Toggle)`
  border-color: var(--input-color) !important;
  overflow: hidden;
`;
